import { capitalize } from '@sonar-software/sonar-ts-lib';
import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';

import { FilterOption, OptionFilter } from '@periscopes/general/filters';

export const ActiveFilter: FilterComponent<string | null | undefined> = (props) => {
	const { format, id, label, metadata, onChange, value } = props;

	const options: Array<FilterOption> = [
		{
			label: capitalize(metadata ? metadata : label ?? ''),
			value: 'true'
		},
		{
			label: `Not ${capitalize(metadata ? metadata : label ?? '')}`,
			value: 'false'
		}
	];

	return (
		<FilterComponent
			{ ...props }
			tagProps={ { value: options.find((option) => option.value === value)?.label } }>
			<OptionFilter
				className='filter'
				getPopupContainer={ getDirectParent }
				id={ getFilterId(id) }
				onChange={ (active: string | null) =>
					onChange({
						[ id ]: {
							format,
							value: active
						}
					}) }
				options={ options }
				placeholder={ PLACEHOLDERS_COPY.FILTER_BY(capitalize(label)) }
				showArrow
				value={ value } />
		</FilterComponent>
	);
};
